import apiClient from '@/api/apiClient';
import type { CnaeList, CnaeListCreate, CnaeListUpdate } from '@/types/cnaeList';
import type { DataCatalogResponse } from '@/types/dataCatalog';

const systemAdminApi = {
    async getCnaeLists(): Promise<CnaeList[]> {
        return apiClient.get('/system-admin/cnae-lists');
    },

    async createCnaeList(newList: CnaeListCreate): Promise<CnaeList> {
        return apiClient.post('/system-admin/cnae-lists', newList);
    },

    async updateCnaeList(id: string, updates: CnaeListUpdate): Promise<CnaeList> {
        return apiClient.put(`/system-admin/cnae-lists/${id}`, updates);
    },

    async deleteCnaeList(id: string): Promise<void> {
        return apiClient.delete(`/system-admin/cnae-lists/${id}`);
    },

    async addCnaesToList(listId: string, cnaeCodes: string[]): Promise<CnaeList> {
        const items = cnaeCodes.map(cnae_code => ({ cnae_code }));
        return apiClient.post(`/system-admin/cnae-lists/${listId}/items`, items);
    },

    async removeCnaesFromList(listId: string, cnaeItemIds: string[]): Promise<CnaeList> {
        return apiClient.delete(`/system-admin/cnae-lists/${listId}/items`, { body: cnaeItemIds });
    },

    async getDataCatalog(): Promise<DataCatalogResponse> {
        return apiClient.get('/system-admin/data-catalog');
    },
};

export default systemAdminApi;
